import { styled } from "@mui/material/styles";
import { Fragment, useEffect, useState } from "react";
import { Box, Grid, Paper, Tooltip, Typography } from "@mui/material";

import { TableCell, TableRow } from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";

import { useAxios } from "../../hooks";

import LoadingButton from "../../components/LoadingButton";

import UserDetailPopUp from "./UserDetailPopUp";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import Color from "../../theme/color";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  min-height: 75vh;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 17px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Box)`
  width: 100%;
  border-radius: 15px;
  min-height: 50vh;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
`;

const TableCells = styled(TableCell)`
  // display: flex;
`;

const EventBox = styled(Grid)`
  background-image: url(${(props) => props.backgroundImage});
  background-size: 100% 100%;
  position: relative;
  background-repeat: no-repeat;
  margin: 0px !important;
  width: 100%;
  height: 25vh !important;
  border-top-left-radius: 12.5px;
  border-top-right-radius: 12.5px;
`;

const GradientOverlay = styled("div")({
  width: "100%",
  height: "100%",
  borderRadius: "12.5px",
  backgroundImage:
    "linear-gradient(rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.62) 100%)",
});

export default function EntrySummary() {
  const axios = useAxios();
  const navigate = useNavigate();

  const { state, search } = useLocation();

  const queryParams = new URLSearchParams(search);

  const entityID = queryParams.get("entity_id");
  const visitorID = queryParams.get("visitor_id");
  const bookingID = queryParams.get("booking_id");
  const userTypeId = queryParams.get("user_type_id");
  const digiLockerID = queryParams.get("id");

  const [badges, setBadges] = useState([]);

  const [open, setOpen] = useState(false);

  const [userDetial, setUserDetial] = useState([]);
  const [userData, setUserData] = useState([]);
  const [userDetialPopUp, setUserDetialPopUp] = useState(false);

  let localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorID) && !item.includes("userPayload");
  });

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });
    if (digiLockerID) {
      axios({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: "aadhar",
          request_id: digiLockerID,
          visitor_id: visitorID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
        },
      }).then((response) => {
        if (response.status) {
          let key = visitorID;
          localStorage.setItem(key, response.data.encrypted_face_data);
        }
      });
    }
  }, []);

  useEffect(() => {
    let url = "admin/profile/get-visitor-booking-status";

    let method = "POST";

    let data = {
      visitor_id: visitorID,
      entity_id: entityID,
      user_type_id: userTypeId,
      booking_id: bookingID,
      face_data: getVisitorFaceData(visitorID),
    };

    axios({
      url: url,
      disableRedirect: true,
      method: method,
      data: data,
    }).then((response) => {
      if (response.status) {
        setUserData(response.data || []);
      }
    });
  }, [axios]);

  const renderInfoItem = (label, value) => (
    <TableRow>
      <TableCells sx={{ width: "40%" }}>
        <Typography
          variant="body1"
          style={{ color: "rgb(150 150 150)" }}
          fontWeight={900}
        >
          {label}
        </Typography>
      </TableCells>
      <TableCells sx={{ width: "60%" }}>
        <Tooltip title={value}>
          <Typography
            variant="h6"
            fontWeight={900}
            sx={{
              color: value === "pending" ? "red" : "black",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "1rem",
              "@media (max-width: 425px)": {
                fontSize: "0.875rem",
              },
            }}
          >
            {value?.toUpperCase()}
          </Typography>
        </Tooltip>
      </TableCells>
    </TableRow>
  );

  return (
    <Fragment>
      <Paper
        elevation={3}
        sx={{
          padding: 3,
          borderRadius: 2,
          mt: 4,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          sx={{
            "@media (min-width:950px)": { width: "50%" },
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: 1,
              marginBottom: 3,
              fontWeight: 900,
            }}
          >
            Entry Summary
          </Typography>

          <Grid container spacing={2} alignItems="center" mt={2}>
            <Grid container justifyContent={"space-around"}>
              {" "}
              <Grid item xs={4} md={1.5} textAlign={"center"}>
                <Typography variant="body1" fontWeight={600}>
                  {userData[0]?.journey_status?.department_name || "GD Ge"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <OuterBox>
        {/* <EventBox
        backgroundImage={
          "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/3e9c86447ad14afb8b260fe48efe0eb0/1724237319019_image-cache.jpeg"
        }
        style={{
          position: "relative",
          backgroundRepeat: "no-repeat",
          margin: " 0px !important",
          width: "92.5%",
          height: "25vh !important",
          borderRadius: "12.5px",
        }}
      >
        <GradientOverlay />
        <Grid
          item
          container
          position="absolute"
          bottom={0}
          sx={{
            justifyContent: "space-between",
            padding: "20px 5%",
          }}
        >
          <Grid item xs={8}>
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{
                WebkitTextStrokeWidth: ".5px",
                fontSize: { xs: "1rem", md: "1.25rem" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Event
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="#747474">
              17 Dec 2013
              <PlaceOutlinedIcon
                sx={{ verticalAlign: "bottom", color: "#3869db" }}
              />
            </Typography>
          </Grid>
        </Grid>
      </EventBox> */}
        {console.log(userData, "userData")}
        {userData?.map((item, index) => {
          return (
            <OuterPaper
              sx={{
                padding: {
                  xs: index != 0 ? "10px 0px 0px 0px" : "20px 0px 0px 0px",
                  sm: index != 0 ? "10px 80px 0px 80px" : "20px 80px 0px 80px",
                },
                alignContent: "start !important",
                minHeight: "0 !important",
              }}
            >
              <Grid
                item
                container
                sx={{
                  border: "0.6px solid #0000001A",
                  borderRadius: "8px",
                  marginTop: "7px",
                }}
              >
                <Grid item container p={"7.5px 0px"}>
                  <Grid item container p={"5px 10px 10px 15px"}>
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        ml: 2,
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight={"bolder"}
                        fontSize={"14px"}
                      >
                        {item.first_name}
                      </Typography>

                      <Typography
                        variant="body1"
                        fontWeight={400}
                        fontSize={"12px"}
                      >
                        {" "}
                        {item.phone_number}
                      </Typography>
                    </Grid>
                    {console.log(
                      !userData[index]?.primary_user,
                      "!userData[index]?.primary_user"
                    )}
                    <Grid
                      item
                      xs={7}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        borderRadius: "4px",
                        alignItems: "center",
                      }}
                    >
                      {userData[index]?.user_type == "primary" &&
                      (index > 0
                        ? !userData[index]?.journey_status?.qr_link
                        : true) ? (
                        <Grid
                          item
                          xs={12}
                          display={"flex"}
                          justifyContent={"center"}
                        >
                          <Grid
                            item
                            container
                            xs={12}
                            sx={{
                              alignSelf: "center",
                              justifyContent: !Boolean(
                                userData[index]?.journey_status?.page_link
                              )
                                ? "end"
                                : "space-evenly",
                            }}
                          >
                            <Grid item xs={4}>
                              <LoadingButton
                                variant="contained"
                                onClick={() => {
                                  setUserDetial(userData[index]);
                                  setUserDetialPopUp(true);
                                }}
                                style={{
                                  fontSize: "12px",
                                  padding: "5px",
                                  marginRight: "4px",
                                }}
                              >
                                Info
                              </LoadingButton>
                            </Grid>

                            {Boolean(
                              userData[index]?.journey_status?.page_link
                            ) && (
                              <Grid item xs={6}>
                                <LoadingButton
                                  variant="outlined"
                                  onClick={() =>
                                    navigate(
                                      userData[index]?.journey_status?.page_link
                                    )
                                  }
                                  disabled={!userData[index]?.primary_user}
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    border: `1px solid ${Color.digipass}`,
                                    color: Color.digipass,
                                  }}
                                  backgroundColor={"white"}
                                >
                                  {userData[index]?.journey_status?.user_status
                                    .toUpperCase()
                                    .replace("_", " ")}
                                </LoadingButton>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      ) : (
                        <Fragment>
                          {Boolean(
                            userData[index]?.journey_status?.page_link
                          ) && (
                            <Grid item container mt={2}>
                              <Grid item xs={4}>
                                {" "}
                                <LoadingButton
                                  variant="contained"
                                  onClick={() => {
                                    setUserDetial(userData[index]);
                                    setUserDetialPopUp(true);
                                  }}
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    marginRight: "4px",
                                  }}
                                >
                                  Info
                                </LoadingButton>
                              </Grid>
                              <Grid item xs={6}>
                                <LoadingButton
                                  variant="outlined"
                                  onClick={() =>
                                    navigate(
                                      userData[index]?.journey_status?.page_link
                                    )
                                  }
                                  disabled={!userData[index]?.primary_user}
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    border: `1px solid ${Color.digipass}`,
                                    color: Color.digipass,
                                  }}
                                  backgroundColor={"white"}
                                >
                                  {userData[index]?.journey_status?.user_status
                                    .toUpperCase()
                                    .replace("_", " ")}
                                </LoadingButton>
                              </Grid>
                            </Grid>
                          )}
                        </Fragment>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </OuterPaper>
          );
        })}

        <UserDetailPopUp
          userDetial={userDetial}
          setUserDetial={setUserDetial}
          userDetialPopUp={userDetialPopUp}
          renderInfoItem={renderInfoItem}
          badges={badges}
          setUserDetialPopUp={setUserDetialPopUp}
        />
      </OuterBox>
    </Fragment>
  );
}
